// Generic Period (year/month) arithmetic and formatting — shared by the
// comparison bar's month/year picker, the trend chart's rolling windows, and
// the footprint map's period labels. No date library is in package.json;
// month-granularity is all this dashboard needs, so plain arithmetic suffices.

import { Period } from './types';

export const MONTH_LABELS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

export function formatPeriod(period: Period): string {
  return `${MONTH_LABELS[period.month - 1]} ${period.year}`;
}

/** Returns the period `deltaMonths` away (negative = earlier, positive = later). */
export function shiftPeriod(period: Period, deltaMonths: number): Period {
  const totalMonths = period.year * 12 + (period.month - 1) + deltaMonths;
  return { year: Math.floor(totalMonths / 12), month: (((totalMonths % 12) + 12) % 12) + 1 };
}

/** Short x-axis/tooltip label; appends a 2-digit year once ranges span more than a year (so repeated month names stay distinguishable). */
export function formatTrendPointLabel(period: Period, includeYear: boolean): string {
  const month = MONTH_LABELS[period.month - 1];
  return includeYear ? `${month} '${String(period.year).slice(-2)}` : month;
}
